import React, { useEffect, useState } from 'react';
import { WalletExample } from './pages/WalletExample';
import { ConnectPage } from 'pages/ConnectPage';
import { Route, Routes } from 'react-router-dom';
import { RegisterTokenPage } from 'pages/RegisterTokenPage';
import { TxLoadingPage } from 'pages/TxLoadingPage';
import { TokenListPage } from 'pages/TokenListPage';
import { BurnPage } from 'pages/BurnPage';
import { LeaderboardPage } from 'pages/LeaderboardPage';
import { PairListPage } from 'pages/PairListPage';
import { RegisterPairPage } from 'pages/RegisterPairPage';
import { SwapPage } from 'pages/SwapPage';
import { SubscribesPage } from 'pages/SubscribesPage';

function App() {

  return (
    <>
      <Routes>
        <Route path='/' element={<ConnectPage />} />
        <Route path='/register-token' element={<RegisterTokenPage />} />
        <Route path='/subscribes/:chatId' element={<SubscribesPage />} />
        <Route path='/tx-loading/:txHash' element={<TxLoadingPage />} />
        <Route path='/token-list' element={<TokenListPage />} />
        <Route path='/burn/:burnAddress' element={<BurnPage />} />
        <Route path='/leaderboard/:burnAddress' element={<LeaderboardPage />} />
        <Route path='/pair-list' element={<PairListPage />} />
        <Route path='/register-pair' element={<RegisterPairPage />} />
        <Route path='/swap/:pairAddress' element={<SwapPage />} />
      </Routes>
    </>
  );
}

export default App;
